import gStPS from '@bqs/templates/assets/products/g-st-p-s.png';
import gSt from '@bqs/templates/assets/products/g-st.png';
import gStGr from '@bqs/templates/assets/products/g-st-gr.png';

/**
 * Technische Schnittdarstellungen, aus den Repository-Assets gebuendelt.
 *
 * **Hier steht keine Zuordnung von Artikeltyp zu Bild.** Sie kommt als `imageRef` aus
 * den Stammdaten (`attribute_value.image_ref`); diese Tabelle bildet nur den
 * Schluessel auf die gebuendelte Datei ab. Eine geaenderte Zuordnung ist damit
 * Pflegearbeit in den Stammdaten und keine Codeaenderung.
 *
 * Vite haengt beim Bauen einen Inhaltshash an den Dateinamen -- die Bilder sind damit
 * dauerhaft cachebar. Keine Base64-Kopie, weder hier noch in der Datenbank.
 */
const BILDER: Record<string, string> = {
  'g-st-p-s': gStPS,
  'g-st': gSt,
  'g-st-gr': gStGr,
};

/**
 * Loest einen Bildschluessel auf.
 *
 * Liefert `null` fuer unbekannte oder fehlende Schluessel. Die Oberflaeche laesst den
 * Bereich dann weg, statt ein kaputtes Bildsymbol zu zeigen.
 */
export function produktbild(imageRef: string | null | undefined): string | null {
  if (imageRef === null || imageRef === undefined) return null;
  return BILDER[imageRef] ?? null;
}
